export const EMPLOYEE_GUIDE_LINKS = [
  { label: "Главная", href: "/" },
  { label: "Войти в MOGAME", href: "/login" },
];

export const EMPLOYEE_GUIDE_SECTIONS = [
  {
    key: "before",
    title: "Перед началом",
    summary: "Что нужно заранее",
    data: [
      {
        point: 1,
        text: "У вас должна быть ссылка от HR или руководителя — обычно её отправляют в корпоративный чат, по email или в LMS.",
      },
      {
        point: 2,
        text: "На телефоне или компьютере установлен Telegram или мессенджер MAX — тот, который указал ваш работодатель.",
      },
      {
        point: 3,
        text: "Если ссылка не открывается, попросите HR прислать её заново или проверить, что программа опубликована.",
      },
    ],
  },
  {
    key: "telegram",
    title: "Telegram",
    summary: "Пошагово в Telegram-боте",
    data: [
      {
        point: 1,
        text: "Нажмите на ссылку от HR. Откроется Telegram (в приложении или в браузере).",
      },
      {
        point: 2,
        text: "Нажмите «Запустить» или «Start» — бот начнёт диалог.",
      },
      {
        point: 3,
        text: "Прочитайте стартовое сообщение и нажимайте кнопки под сообщениями, чтобы двигаться дальше.",
      },
      {
        point: 4,
        text: "Если бот прислал видео — дождитесь загрузки и смотрите до конца, затем выберите ответ или следующий шаг.",
      },
      {
        point: 5,
        text: "Проходите программу до конца. Если разрешено повторное прохождение, в конце можно начать заново.",
      },
    ],
  },
  {
    key: "max",
    title: "MAX",
    summary: "Пошагово в боте MAX",
    data: [
      {
        point: 1,
        text: "Нажмите на ссылку от HR. Откроется мессенджер MAX.",
      },
      {
        point: 2,
        text: "Подтвердите запуск бота, если приложение спросит разрешение.",
      },
      {
        point: 3,
        text: "Следуйте кнопкам под сообщениями — они ведут по шагам программы.",
      },
      {
        point: 4,
        text: "Если видео не загружается, проверьте интернет и попробуйте ещё раз через минуту.",
      },
    ],
  },
  {
    key: "troubles",
    title: "Если что-то не работает",
    summary: "Частые ситуации",
    data: [
      {
        point: 1,
        text: "«Ссылка не открывается» — попросите HR проверить, что проект опубликован и подписка компании активна.",
      },
      {
        point: 2,
        text: "«Бот не отвечает» — закройте чат и откройте ссылку снова. Убедитесь, что нажали «Запустить» / Start.",
      },
      {
        point: 3,
        text: "«Мест в команде не осталось» — HR нужно расширить тариф или освободить место. Обратитесь к ответственному за обучение.",
      },
      {
        point: 4,
        text: "«Нужна помощь по содержанию программы» — напишите HR или наставнику. В некоторых программах есть кнопка «Связаться с поддержкой».",
      },
    ],
  },
];
